import { h } from 'preact';
import {
    logoAmericanExpressLogos,
    logoAura,
    logoCircleCard,
    logoCredCard,
    logoDiscovery,
    logoElo,
    logoHipercard,
    logoJcb,
    logoVisa
} from "../../../../assets";

const CreditCards = (props) => {
    const {styles = ''} = props;

    return (
        <div className="flex flex-wrap justify-content-center">
            <img
                 src={logoCredCard}
                 className={`mr-2 mt-2 mt-sm-0 ${styles} dark:grayscale`}
                 alt="credcard"
                 data-testid="credit-card-credcard"
            />
            <img
                 src={logoVisa}
                 className={`mr-2 mt-2 mt-sm-0 ${styles} dark:grayscale`}
                 alt="visa"
                 data-testid="credit-card-visa"
            />
            <img
                 src={logoAmericanExpressLogos}
                 className={`mr-2 mt-2 mt-sm-0 ${styles} dark:grayscale`}
                 alt="american express"
                 data-testid="credit-card-american-express"
            />
            <img
                 src={logoCircleCard}
                 className={`mr-2 mt-2 mt-sm-0 ${styles} dark:grayscale`}
                 alt="circle card"
                 data-testid="credit-card-circle-card"
            />
            <img
                 src={logoElo}
                 className={`mr-2 mt-2 mt-sm-0 ${styles} dark:grayscale`}
                 alt="elo"
                 data-testid="credit-card-elo"
            />
            <img
                 src={logoJcb}
                 className={`mr-2 mt-2 mt-sm-0 ${styles} dark:grayscale`}
                 alt="jcb"
                 data-testid="credit-card-jcb"
            />
            <img
                 src={logoDiscovery}
                 className={`mr-2 mt-2 mt-sm-0 ${styles} dark:grayscale`}
                 alt="discovery"
                 data-testid="credit-card-discovery"
            />
            <img
                 src={logoHipercard}
                 className={`mr-2 mt-2 mt-sm-0 ${styles} dark:grayscale`}
                 alt="hipercard"
                 data-testid="credit-card-hipercard"
            />
            {/*<img*/}
            {/*     src={logoAura}*/}
            {/*     className={`mt-2 mt-sm-0 ${styles} dark:grayscale`}*/}
            {/*     alt="aura"*/}
            {/*     data-testid="credit-card-aura"*/}
            {/*/>*/}
        </div>
    )
};

export default CreditCards;